import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import './SurveyTitle.scss';

type SurveyTitleProps = {
  className?: string;
};

export const SurveyTitle: React.FC<PropsWithChildren<SurveyTitleProps>> = ({
  children,
  className,
}) => {
  return <div className={clsx('survey-title', className)}>{children}</div>;
};
